module.exports = __webpack_public_path__ + "img/CEDULASWEB.76580139.svg";